import React from 'react';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  USYS_DATA_ATTRS,
  USYS_USER_STATES,
} from '@packages/systems/users/constants';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {TText, TEnum, TRecord} from '@packages/systems/wfdl-ast';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {getStringOrElse, getInPojo} from '@packages/utilities/data-utils';

const UserLogOutLogIn = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    // Default to logged in and show the button if we're in the designer.
    const userState = getStringOrElse(
      getInPojo(data, ['temp', 'state']),
      runtimeEnvironment === WebflowEnvironments.DESIGNER
        ? USYS_USER_STATES.loggedIn
        : USYS_USER_STATES.loggedOut
    );

    const loggedInText = getStringOrElse(
      getInPojo(data, ['loggedInButtonText']),
      'Log out'
    );
    const loggedOutText = getStringOrElse(
      getInPojo(data, ['loggedOutButtonText']),
      'Log in'
    );
    const textToRender =
      userState === USYS_USER_STATES.loggedIn ? loggedInText : loggedOutText;

    return (
      <button
        {...generateAttributes(attributes, classes)}
        {...{
          [USYS_DATA_ATTRS.logout]: loggedInText,
          [USYS_DATA_ATTRS.login]: loggedOutText,
        }}
        type="button"
      >
        {textToRender}
      </button>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'User Log In/Log Out',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Users'), iconName('Logout')),
  },
  render: UserLogOutLogIn,
  showEmpty: false,
  lockedStyles: {
    display: {
      when: true,
      message: 'The display setting can’t be changed for a logout button.',
    },
  },
  fields: {
    loggedInButtonText: withSystem(
      {
        defaultValue: 'Log out',
        label: 'Logged in button text',
        displayName: 'Logged in button text',
        isFullWidth: true,
      },
      TText
    ),
    loggedOutButtonText: withSystem(
      {
        defaultValue: 'Log in',
        label: 'Logged out button text',
        displayName: 'Logged out button text',
        isFullWidth: true,
      },
      TText
    ),
    temp: TRecord({
      state: withSystem(
        {
          label: 'Show state',
          defaultValue: 'loggedIn',
          isFullWidth: true,
        },
        TEnum({
          [USYS_USER_STATES.loggedIn]: 'Logged in',
          [USYS_USER_STATES.loggedOut]: 'Logged out',
        })
      ),
    }),
  },
});

export default config;
